<template>
  <BaseIcon
    :active="active"
    :dark-mode="darkMode"
    :width="width"
    :height="height"
    :svg-path="'M20.0002 4.00021C20.0002 3.45021 19.5502 3.00021 19.0002 3.00021H12.0002C11.4502 3.00021 11.0002 3.45021 11.0002 4.00021C11.0002 4.55021 11.4502 5.00021 12.0002 5.00021H19.0002C19.5502 5.00021 20.0002 4.55021 20.0002 4.00021ZM11.0002 12.0002C11.0002 12.5502 11.4502 13.0002 12.0002 13.0002H19.0002C19.5502 13.0002 20.0002 12.5502 20.0002 12.0002C20.0002 11.4502 19.5502 11.0002 19.0002 11.0002H12.0002C11.4502 11.0002 11.0002 11.4502 11.0002 12.0002ZM8.47022 0.630215C8.86022 1.02021 8.86022 1.65021 8.47022 2.04021L4.24022 6.29021C3.85022 6.68021 3.22022 6.68021 2.82022 6.29021L0.700224 4.16021C0.513246 3.97324 0.408203 3.71964 0.408203 3.45521C0.408203 3.32428 0.433992 3.19464 0.484097 3.07367C0.534202 2.95271 0.607642 2.8428 0.700224 2.75021C0.792806 2.65763 0.902716 2.58419 1.02368 2.53409C1.14464 2.48398 1.27429 2.45819 1.40522 2.45819C1.66965 2.45819 1.92325 2.56324 2.11022 2.75021L3.53022 4.17021L7.07022 0.630215C7.45022 0.250215 8.09022 0.250215 8.47022 0.630215ZM8.48022 8.64021C8.87022 9.03022 8.87022 9.66021 8.48022 10.0502L4.25022 14.3002C3.86022 14.6902 3.23022 14.6902 2.83022 14.3002L0.700224 12.1602C0.607642 12.0676 0.534202 11.9577 0.484097 11.8368C0.433992 11.7158 0.408203 11.5861 0.408203 11.4552C0.408203 11.3243 0.433992 11.1946 0.484097 11.0737C0.534202 10.9527 0.607642 10.8428 0.700224 10.7502C0.792806 10.6576 0.902716 10.5842 1.02368 10.5341C1.14464 10.484 1.27429 10.4582 1.40522 10.4582C1.53615 10.4582 1.6658 10.484 1.78677 10.5341C1.90773 10.5842 2.01764 10.6576 2.11022 10.7502L3.53022 12.1702L7.07022 8.63021C7.45022 8.25021 8.09022 8.25022 8.48022 8.64021Z'" />
</template>

<script>
import BaseIcon from "./BaseIcon.vue"
export default {
  components: {
    BaseIcon
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    darkMode: {
      type: Boolean,
      default: false
    },
    width: {
      type: [Number, String],
      default: 22
    },
    height: {
      type: [Number, String],
      default: 22
    }
  }
}
</script>
